import { Stack } from '@koob/margaret';
import { useTheme } from 'styled-components';
import { Text } from 'ui';
import PillStatus from './PillStatus';

export const PromotionTitleInfo = ({ name, status }) => {
  const theme = useTheme();
  if (!Boolean(name) || !Boolean(status)) return null;
  return (
    <Stack
      style={{ marginLeft: theme.spacing(0.5) }}
      direction="row"
      alignY="center"
      gutterSize={0.5}
    >
      <i
        className="fa-light fa-chevron-right"
        style={{ fontSize: 18 }}
        aria-hidden="true"
      />
      <Text type="h1" as="span" style={{ fontWeight: 'normal' }}>
        {name}
      </Text>
      <PillStatus value={status} emptyValue={null} />
    </Stack>
  );
};
